import React, { useState, useEffect } from 'react';
import { Table } from 'antd';
import CssBaseline from '@material-ui/core/CssBaseline';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import TextEvents from 'app/components/TextEvents';
import Paper from '@material-ui/core/Paper';

import NavMenu from 'components/NavMenu';
import { useStyles, styles } from './HomologousProcedureScreenStyles';
import HomologousProcedureForm from 'app/components/HomologousProcedureForm';
import HomologousProcedureTableContainer from 'app/containers/HomologousProcedureTableContainer';

import { useDispatch } from 'react-redux';
import { homologousProcedureClear } from 'app/actions/HomologousProcedureActions';

export default function HomologousProcedureScreen(props) {
    const classes = useStyles();
    const dispatch = useDispatch();

    const [pagination, setPagination] = useState({ defaultCurrent: 1, defaultPageSize: 25, pageSize: 25, total: 0, showSizeChanger: true, pageSizeOptions: ['25', '50', '100'], showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros` });
    const [sorter, setSorter] = useState({});
    const [formData, setFormData] = useState({});
    const [filter, setFilter] = useState([]);
    const [visibleForm, isVisibleForm] = useState(false)
    const [idProcedure, setIdProcedure] = useState(0);
    const [nameProcedure, setNameProcedure] = useState('');
    const [codeProcedure, setCodeProcedure] = useState('');
    const [FiltroNombre, setFiltroNombre] = useState([]);
    const [FiltroCompany, setFiltroCompany] = useState([]);
    const [FiltroCodigo, setFiltroCodigo] = useState([]);

    const [idClient, setIdClient] = useState('0');

    const [height, setHeight] = useState(window.innerHeight);
    window.addEventListener('resize', () => {
        setHeight(window.innerHeight);
    });

    useEffect(() => {
        return () => {
            dispatch(homologousProcedureClear());
        }
    }, []);
    return (
        <div className={classes.root}>
            <NavMenu SelectedIndex={props.history.location.pathname} isCatalog={true} header='Procedimientos Homólogos' isCommunicationStatus={false} />
            <CssBaseline />
            <div className={`${classes.content}`}>
                <div className={classes.appBarSpacer} />
                <div elevation={0} style={styles.titleBox}>
                    <Breadcrumbs aria-label="Breadcrumb">
                        <Link color="inherit" disabled>
                            Catálogos
                        </Link>
                        <TextEvents
                            text="Catálogo de Procedimientos Homólogos"
                            color="cotemar"
                            size='subtitle'
                            weight="bold"
                        />
                    </Breadcrumbs>
                </div>
                <Paper className={classes.rootPaper}>
                    <HomologousProcedureForm idProcedure={idProcedure} setIdProcedure={setIdProcedure} nameProcedure={nameProcedure} setNameProcedure={setNameProcedure} codeProcedure={codeProcedure} setCodeProcedure={setCodeProcedure} idClient={idClient} setIdClient={setIdClient} visibleForm={visibleForm} isVisibleForm={isVisibleForm} filter={filter} setFilter={setFilter} pagination={pagination} sorter={sorter} formData={formData} setFormData={setFormData} FiltroNombre={FiltroNombre} setFiltroNombre={setFiltroNombre} FiltroCompany={FiltroCompany} setFiltroCompany={setFiltroCompany} FiltroCodigo={FiltroCodigo} setFiltroCodigo={setFiltroCodigo} />
                    <div style={styles.baseVerticalMargin}>
                        <HomologousProcedureTableContainer setIdProcedure={setIdProcedure} setNameProcedure={setNameProcedure} setCodeProcedure={setCodeProcedure} setIdClient={setIdClient} isVisibleForm={isVisibleForm} classes={classes} filter={filter} sorter={sorter} setSorter={setSorter} pagination={pagination} setPagination={setPagination} formData={formData} FiltroNombre={FiltroNombre} setFiltroNombre={setFiltroNombre} FiltroCompany={FiltroCompany} setFiltroCompany={setFiltroCompany} FiltroCodigo={FiltroCodigo} setFiltroCodigo={setFiltroCodigo}>
                            {(params) => {
                                return (
                                    <div>
                                        <Table
                                            useFixedHeader={true}
                                            loading={params.isLoading}
                                            rowKey={item => String(item.idProcedure)}
                                            columns={params.cols}
                                            dataSource={params.homologousProcedure}
                                            onChange={params.handleTableChange}
                                            pagination={pagination}
                                            // scroll={{ y: 700, x: "min-content" }}
                                            scroll={{ x: 'min-content', y: (height - 500) }}
                                            size={"small"}

                                        />
                                    </div>
                                )
                            }}
                        </HomologousProcedureTableContainer>
                    </div>
                </Paper>


            </div>
        </div>
    )
}